module.exports = __webpack_public_path__ + "8aa3588e761834b5c4e8df1ade562b7b.svg";